import CheckBoxGroup from '@pc/components/Works/Panel/shared/Checkbox/CheckBoxGroup'
import CheckBoxInput from '@pc/components/Works/Panel/shared/Checkbox/CheckBoxInput'
import CheckBoxInputSet from '@pc/components/Works/Panel/shared/Checkbox/CheckBoxInputSet'
import CheckBoxLabel from '@pc/components/Works/Panel/shared/Checkbox/CheckBoxLabel'
import type { Line, Station } from '@pc/components/Works/Panel/types'
import type { ChangeEvent, ChangeEventHandler, ComponentPropsWithoutRef } from 'react'

interface PropsType {
  line: Line
  stations: Station[]
  selectedStationIds: string[]
  changeStationIds: (stationIds: string[]) => void
}

const CheckBoxStationInputSet = (props: ComponentPropsWithoutRef<'li'>) => (
  <CheckBoxInputSet className="mr-2.5 flex w-27.5 items-center leading-snug" {...props} />
)

// ControlGroupのmt-2.5はclassNameで打ち消せないため独立させている
const StationControlGroup = (props: ComponentPropsWithoutRef<'div'>) => <div className="mx-4 mb-4 cursor-default bg-[#f5f5f5] p-4" {...props} />

const renderStationCheckboxes = (stations: Station[], selectedStationIds: string[], toggleCheckbox: ChangeEventHandler) => {
  return stations.map((station) => {
    const stationId = `station-${station.id}`
    return (
      <CheckBoxStationInputSet key={station.id}>
        <CheckBoxInput
          type="checkbox"
          id={stationId}
          value={station.attributes.id}
          onChange={toggleCheckbox}
          checked={selectedStationIds.includes(String(station.attributes.id))}
        />
        <CheckBoxLabel htmlFor={stationId}>{station.attributes.name}</CheckBoxLabel>
      </CheckBoxStationInputSet>
    )
  })
}

const StationCheckboxes = (props: PropsType) => {
  const { line, stations, selectedStationIds, changeStationIds } = props

  const toggleCheckbox = (e: ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = e.target

    if (checked) {
      const concatedStationIds = selectedStationIds.concat(value)
      changeStationIds(concatedStationIds)
      return
    }

    const filteredStationIds = selectedStationIds.filter((selectedStationId) => selectedStationId !== value)
    changeStationIds(filteredStationIds)
  }

  const toggleAllCheckbox = () => {
    const stationIds: string[] = stations.map((station) => station.attributes.id.toString())

    if (isAllSelected()) {
      changeStationIds(selectedStationIds.filter((selectedStationId) => !stationIds.includes(selectedStationId)))
    } else {
      changeStationIds([...new Set([...selectedStationIds, ...stationIds])])
    }
  }

  const isAllSelected = () => {
    const stationIds = stations.map((station) => station.attributes.id.toString())
    return stationIds.every((stationId) => selectedStationIds.includes(stationId))
  }

  const lineId = `line-${line.id}`

  return (
    <StationControlGroup>
      <CheckBoxGroup>
        <CheckBoxInputSet>
          <CheckBoxInput type="checkbox" id={lineId} onChange={toggleAllCheckbox} checked={isAllSelected()} />
          <CheckBoxLabel htmlFor={lineId}>{line.attributes.name}全て</CheckBoxLabel>
        </CheckBoxInputSet>
      </CheckBoxGroup>
      <CheckBoxGroup>{renderStationCheckboxes(stations, selectedStationIds, toggleCheckbox)}</CheckBoxGroup>
    </StationControlGroup>
  )
}

export default StationCheckboxes
